export default __webpack_public_path__ + "static/media/button_off.bb49aec8.mp3";